// src/stores/useNotificationStore.js
import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    message: '',
    type: 'info', // 'success', 'error', 'warning', 'info'
    isVisible: false,
    duration: 5000, // Auto-hide after 5 seconds
    timeoutId: null,
  }),

  actions: {
    showNotification(message, type = 'info', duration = 5000) {
      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      this.message = message
      this.type = type
      this.isVisible = true
      this.duration = duration

      // Auto-hide after specified duration
      if (duration > 0) {
        this.timeoutId = setTimeout(() => {
          this.hideNotification()
        }, duration)
      }
    },

    hideNotification() {
      this.isVisible = false
      this.message = ''
      
      // Clear timeout if it exists
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
    },

    // Convenience methods for different notification types
    showSuccess(message, duration = 5000) {
      this.showNotification(message, 'success', duration)
    },

    showError(message, duration = 7000) {
      this.showNotification(message, 'error', duration)
    },

    showWarning(message, duration = 6000) {
      this.showNotification(message, 'warning', duration)
    },

    showInfo(message, duration = 5000) {
      this.showNotification(message, 'info', duration)
    },
  },
})
